import React, {Component} from "react";
/*
    For Redux, importing connect and action
    Redux connect is to access Redux states
    Redux actions to update the Redux states
*/
import { connect } from "react-redux";
import { updateForm, setPage } from "../../../../store/actions/FormAction";

/*
    Loan Doc 1 view that displays the Loan doc page
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
    SVGs need to have the xml attributes removed
*/
class PrivacyPolicy extends Component {
  componentDidMount() {
    this.props.updateForm("pagename", "Privacy Policy");
    this.props.setPage("privacypolicy");
  }
  render() {

    return (
      <div id="dashboard2">
        <div className="dashheader">
          Privacy Policy
        </div>
        <div className="container text-center documentheader padbottom">
          <p className="buttontitle padtop">Privacy Policy</p>
          <div className="button-group padtop15">
            <a className="btn yesno">Print</a> <a className="btn yesno">Download</a>
          </div>
        </div>
        <div className="container" style={{border:'1px solid #000'}}>
        <h2>MoneyKey Privacy Policy</h2>
        <p className="text-right font-12">Rev. February 1 2017</p>
        <p>Please note that this Privacy Policy is supplemented by MoneyKey&#39;s <a target="_blank" rel="noopener noreferrer" href="https://www.moneykey.com/online-privacy-policy.php">Online Privacy Policy</a> which describes our online practices and applies to anyone who visits our website and/or any MoneyKey-branded social media sites or pages.
        Please refer to that document to understand how MoneyKey manages personal information provided to MoneyKey through our website.</p>
        <table>
          <tbody>
            <tr>
              <td className="td-1 bg-grey color-white">
                <p className="text-center">FACTS</p>
              </td>
              <td className="td-2">
                <p>WHAT DO 2288984 ONTARIO INC., 2262011 ONTARIO-HOLDINGS, INC., 2262011 ONTARIO – DELAWARE, INC., MONEYKEY – AL, INC., MONEYKEY – DE, INC., MONEYKEY – IL, INC., MONEYKEY – KS, INC., MONEYKEY – MD, INC., MONEYKEY – MO, INC., MONEYKEY – NM, INC., MONEYKEY – OH, INC., MONEYKEY – SC, INC., MONEYKEY – SD, INC., MONEYKEY – TX, INC., MONEYKEY – UT, INC. (COLLECTIVELY REFERRED TO HERE AS "MONEYKEY") DO WITH YOUR PERSONAL INFORMATION?</p>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <tbody>
            <tr>
              <td className="td-1 bg-grey" colspan="1">
                <p className="text-center color-white">Why?</p>
              </td>
              <td className="td-2" colspan="1">
                <p>Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share, and protect your personal information. Please read this notice carefully to understand what we do.</p>
              </td>
            </tr>
            <tr>
              <td className="td-1 bg-grey" colspan="1"> <p className="text-center color-white">What?</p></td>
              <td className="td-2" colspan="1"> <p>The type of personal information we collect and share depends on the product or service you apply for with MoneyKey. This information can include:</p>
                <ul>
                  <li>Social Security Number and bank account information</li>
                  <li>Account balances and income</li>
                  <li>Payment history and credit history</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td className="td-1 bg-grey" colspan="1">
              <p className="text-center color-white">How?</p>
              </td>
              <td className="td-2" colspan="1">
              <p>All financial companies need to share customers&#39; personal information to run their everyday business. In the section below, we list the reasons financial companies can share their customers&#39; personal information; the reason MoneyKey chooses to share; and whether you can limit this sharing.</p>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <tbody>
          <tr>
            <td className="td-1 bg-grey" colspan="1"> <p className="text-center color-white">Reasons we can share your personal information</p></td>
            <td className="td-1 bg-grey" colspan="1"> <p className="text-center color-white">Does MoneyKey share?</p></td>
            <td className="td-1 bg-grey" colspan="1"> <p className="text-center color-white">Can you limit this sharing?</p></td>
          </tr>
          <tr>
            <td className="td-1" colspan="1"> <p className="text-center"><b>For our everyday business purposes</b> - such as to process your transactions, maintain your account(s), respond to court orders and legal investigations, or report to credit bureaus</p></td>
            <td className="td-1" colspan="1"> <p className="text-center">Yes</p></td>
            <td className="td-1" colspan="1"> <p className="text-center">No</p></td>
          </tr>
          <tr>
            <td className="td-1" colspan="1"> <p className="text-center"><span className="bold">For our marketing purposes</span> - offer our products and services to you</p></td>
            <td className="td-1" colspan="1"> <p className="text-center">Yes</p></td>
            <td className="td-1" colspan="1"> <p className="text-center">No</p></td>
          </tr>
          <tr>
            <td className="td-1" colspan="1"> <p className="text-center bold">For joint marketing with other financial companies</p></td>
            <td className="td-1" colspan="1"> <p className="text-center">Yes</p></td>
            <td className="td-1" colspan="1"> <p className="text-center">No</p></td>
          </tr>
          <tr>
            <td className="td-1" colspan="1"> <p className="text-center"><span className="bold">For our affiliates&#39; everyday business purposes</span> - information about your transactions and experiences</p></td>
            <td className="td-1" colspan="1"> <p className="text-center">Yes</p></td>
            <td className="td-1" colspan="1"> <p className="text-center">No</p></td>
          </tr>
          <tr>
            <td className="td-1" colspan="1">
            <p className="text-center"><span className="bold">For our affiliates&#39; everyday business purposes</span> - about your creditworthiness</p></td>
            <td className="td-1" colspan="1"> <p className="text-center">Yes</p></td>
            <td className="td-1" colspan="1"> <p className="text-center">Yes</p></td>
          </tr>
          <tr>
            <td className="td-1" colspan="1"> <p className="text-center bold">For our affiliates to market to you</p></td>
            <td className="td-1" colspan="1"> <p className="text-center">Yes</p></td>
            <td className="td-1" colspan="1"> <p className="text-center">Yes</p></td>
          </tr>
          <tr>
            <td className="td-1" colspan="1"> <p className="text-center">For non-affiliates to market to you</p></td>
            <td className="td-1" colspan="1"> <p className="text-center">Yes</p></td>
            <td className="td-1" colspan="1"> <p className="text-center">Yes</p></td>
          </tr>
          </tbody>
        </table>
        <table>
          <tbody>
            <tr>
              <td className="td-1 bg-grey" colspan="1">
                <p className="text-center color-white">To limit our sharing</p>
              </td>
              <td className="td-1" colspan="1">
                <ul>
                  <li><a href="tel:1-866-255-1668">Call 1-866-255-1668</a></li>
                  <li><a href="mailto:customercare@moneykey.com">Email us at customercare@moneykey.com</a></li>
                  <li><a target="_blank" rel="noopener noreferrer" href="https://www.moneykey.com/">Visit our website at www.moneykey.com</a></li>
                </ul>
                <p className="bold">PLEASE NOTE:</p>
                <p>If you are a new customer, we can begin sharing your information 30 days from the date you are made aware of this notice. When you are no longer our customer, we continue to share your information as described in this notice.</p>
                <p>However, you can contact us at any time to limit our sharing.</p>
              </td>
            </tr>
            <tr>
              <td className="td-1 bg-grey" colspan="1">
                <p className="text-center color-white">Questions?</p>
              </td>
              <td className="td-1" colspan="1">
                <ul>
                  <li><a href="tel:1-866-255-1668">Call 1-866-255-1668</a></li>
                  <li><a href="mailto:customercare@moneykey.com">Email us at customercare@moneykey.com</a></li>
                  <li><a target="_blank" rel="noopener noreferrer" href="https://www.moneykey.com/">Visit our website at www.moneykey.com</a></li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <tbody>
            <tr>
              <td className="td-1 bg-grey" colspan="2">
                <p className="color-white">Who we are</p>
              </td>
            </tr>
            <tr>
              <td className="td-1" colspan="1">
                <p className="bold">Who is providing this notice?</p>
              </td>
              <td className="td-1" colspan="1">
                <p>MoneyKey, and its Affiliates, is providing this notice, and it applies to all loans and lines of credit made, arranged, serviced or guaranteed by MoneyKey and its Affiliates, and all products and services offered in connection with such loans and lines of credit.</p>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <tbody>
            <tr>
              <td className="td-1 bg-grey" colspan="2">
                <p className="color-white">What we do</p>
              </td>
            </tr>
            <tr>
              <td className="td-1" colspan="1">
                <p className="bold">How does MoneyKey protect my personal information?</p>
              </td>
              <td className="td-1" colspan="1">
                <p>To protect your personal information from unauthorized access and use, we use security measures that comply with federal law. These measures include computer safeguards and secured files and buildings.</p>
              </td>
            </tr>
            <tr>
              <td className="td-1" colspan="1">
                <p className="bold">How does MoneyKey collect my personal information?</p>
              </td>
              <td className="td-1" colspan="1">
                <p>We collect your personal information, for example, when you</p>
                <ul>
                  <li>apply for a loan or line of credit</li>
                  <li>give us your income information</li>
                  <li>tell us where to send the money</li>
                  <li>provide account information</li>
                  <li>provide employment information</li>
                </ul>
                <p>We also collect your personal information from others, such as credit bureaus, affiliates or other companies.</p>
              </td>
            </tr>
            <tr>
              <td className="td-1" colspan="1">
                <p className="bold">Why can&#39;t I limit all sharing?</p>
              </td>
              <td className="td-1" colspan="1"> <p>Federal law gives you the right to limit only</p>
                <ul>
                  <li>sharing for affiliates&#39; everyday business purposes - information about your creditworthiness</li>
                  <li>affiliates from using your information to market to you</li>
                  <li>sharing for nonaffiliates to market to you</li>
                </ul>
                <p>State laws and individual companies may give you additional rights to limit sharing. See below for more on your rights under state law.</p>
              </td>
            </tr>
            <tr>
              <td className="td-1" colspan="1">
                <p className="bold">What happens when I limit sharing for an account I hold jointly with someone else?</p>
              </td>
              <td className="td-1" colspan="1">
                <p>Your choices will apply to everyone on your account.</p>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <tbody>
            <tr>
              <td className="td-1 bg-grey" colspan="2">
                <p className="color-white">Definitions</p>
              </td>
            </tr>
            <tr>
              <td className="td-1" colspan="1">
                <p className="bold">Affiliates</p>
              </td>
              <td className="td-1" colspan="1">
                <p>Companies related by common ownership or control. They can be financial and nonfinancial companies.</p>
                <ul>
                  <li>2288984 Ontario Inc.,</li>
                  <li>2262011 Ontario Holdings, Inc.</li>
                  <li>2262011 Ontario-Delaware, Inc.</li>
                  <li>MoneyKey - AL, Inc.</li>
                  <li>MoneyKey - DE, Inc.</li>
                  <li>MoneyKey - IL, Inc.</li>
                  <li>MoneyKey - KS, Inc.</li>
                  <li>MoneyKey - MD, Inc.</li>
                  <li>MoneyKey - MO, Inc.</li>
                  <li>MoneyKey - NM, Inc.</li>
                  <li>MoneyKey - OH, Inc.</li>
                  <li>MoneyKey - SC, Inc.</li>
                  <li>MoneyKey - SD, Inc.</li>
                  <li>MoneyKey - TX, Inc.</li>
                  <li>MoneyKey - UT, Inc.</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td className="td-1" colspan="1"> <p className="bold">Nonaffiliates</p></td>
              <td className="td-1" colspan="1">
                <p>Companies not related by common ownership or control. They can be financial and nonfinancial companies.</p>
                <ul>
                  <li>Nonaffiliates we share with can include other lenders and direct marketing companies.</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td className="td-1" colspan="1"> <p className="bold">Joint marketing</p></td>
              <td className="td-1" colspan="1">
                <p>A formal agreement between non-affiliated financial companies that together market financial products or services to you.</p>
                <ul>
                  <li>Our joint marketing partners can include institutions such as other lenders or marketers.</li>
                </ul>
              </td>
            </tr>
           </tbody>
         </table>
         <table>
           <tbody>
             <tr>
                <td className="td-1 bg-grey" colspan="2">
                  <p className="color-white">Other important information</p>
                </td>
             </tr>
             <tr>
                <td className="td-1" colspan="2">
                  <p>If we extend credit to a consumer, or guarantee credit offered to a consumer by an unaffiliated 3rd party lender, we will consider the bank account information provided by the consumer as eligible for us to process payments against. In addition, as part of our information collection process, we may detect additional bank accounts under the ownership of the consumer. We will consider any information collected about these additional accounts as part of the consumer&#39;s application and may use such information in our underwriting processes.</p>
                  <p><span className="bold">Use of Auto-Dialers</span> – MoneyKey, and/or our affiliates, may contact you via text messages and/or telephone calls at the telephone number you provided using auto-dialers and/or pre-recorded messages.</p>
                  <p><span className="bold">California residents</span> – California law requires financial institutions to obtain your consent prior to sharing your personal information with non-affiliated third parties. If you are a resident of California, we will not share information we collect about you with non-affiliated third parties without your consent, except as permitted by law.</p>
                </td>
             </tr>
           </tbody>
         </table>
        </div>
      </div>
      );
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setPage: (page) => dispatch(setPage(page)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicy)



// WEBPACK FOOTER //
// ./src/components/views/Dashboard/documents/PrivacyPolicy.js